import type { BillingEntity } from "@shared/lib/types/briefCampains";
import type { PanVerificationStatus } from "@entities/campaigns/lib/hooks/useVerifyPan";

export type BillingFormInitialValues = {
  contactType: "email" | "phone";
  emailId?: string;
  phoneNumber?: string;
  countryCode?: string;
  billingType?: "Individual" | "Company" | string;
  isInternational: boolean;
  name?: string;
  addressLine1?: string;
  addressLine2?: string;
  city?: string;
  state?: string;
  pinCode?: string;
  country?: string;
  isPan: boolean;
  panNumber?: string;
  tdsPercentage: number;
  isMsme: boolean;
  msmeNumber?: string;
  isGst: boolean;
  gstNumber?: string;
};

export function mapBillingEntityToFormValues(
  entity: BillingEntity
): BillingFormInitialValues {
  const hasPhone = Boolean(entity.phoneNumber);

  return {
    contactType: hasPhone ? "phone" : "email",
    emailId: entity.emailId || undefined,
    phoneNumber: entity.phoneNumber || undefined,
    countryCode: entity.countryCode || undefined,
    billingType: entity.billingType || undefined,
    isInternational: Boolean(entity.isInternational),
    name: entity.name || undefined,
    addressLine1: entity.addressLine1 || undefined,
    addressLine2: entity.addressLine2 || undefined,
    city: entity.city || undefined,
    state: entity.state || undefined,
    pinCode: entity.pinCode || undefined,
    country: entity.country || undefined,
    isPan: Boolean(entity.isPan),
    panNumber: entity.panNumber || undefined,
    tdsPercentage:
      typeof entity.tdsPercentage === "number" ? entity.tdsPercentage : 10,
    isMsme: Boolean(entity.isMsme),
    msmeNumber: entity.msmeNumber || undefined,
    isGst: Boolean(entity.isGst),
    gstNumber: entity.gstNumber || undefined,
  };
}

export function getInitialPanStatus(
  entity?: BillingEntity | null
): PanVerificationStatus | null {
  if (!entity?.isPan && !entity?.panNumber) return null;
  const status = entity.panVerification?.status;
  if (status === "Valid" || status === "Invalid") return status;
  return null;
}
